import { pageHeaderHeight } from '@/constants'
import { useLayout, useMe } from '@/providers'
import Logo from '@components/Logo/Logo'
import { useBoolVariation } from '@launchdarkly/react-sdk'
import { Stack } from '@mui/material'
import { Link } from 'react-router-dom'

import NotificationBell from './NotificationBell/NotificationBell'
import UserMenu from './UserMenu/UserMenu'
import UserMenuOld from './UserMenu/UserMenuOld'

export default function PageHeader() {
	const me = useMe()
	const { sidebarExpanded } = useLayout()
	const notificationsEnabled = useBoolVariation('feature-art-1588-in-app-notifications', false)

	return (
		<Stack
			direction="row"
			sx={{
				px: 2,
				justifyContent: sidebarExpanded ? 'flex-end' : 'space-between',
				alignItems: 'center',
				height: pageHeaderHeight,
				flexShrink: 0,
				bgcolor: 'primary.main',
				width: '100%',
			}}
		>
			{!sidebarExpanded && (
				<Link to="/app" data-testid="sidebar-logo" style={{ width: '100%' }}>
					<Logo variant="white" style={{ height: '1.75rem' }} />
				</Link>
			)}

			{notificationsEnabled && <NotificationBell />}
			{notificationsEnabled ? <UserMenu user={me} /> : <UserMenuOld user={me} />}
		</Stack>
	)
}
